const _temp0 = require("./H1_Julistepeli_1.png");
const _temp1 = require("./H1_Julistepeli_10.png");
const _temp2 = require("./H1_Julistepeli_2.png");
const _temp3 = require("./H1_Julistepeli_3.png");
const _temp4 = require("./H1_Julistepeli_4.png");
const _temp5 = require("./H1_Julistepeli_5.png");
const _temp6 = require("./H1_Julistepeli_6.png");
const _temp7 = require("./H1_Julistepeli_7.png");
const _temp8 = require("./H1_Julistepeli_8.png");
const _temp9 = require("./H1_Julistepeli_9.png");
module.exports = {
  "H1_Julistepeli_1": _temp0,
  "H1_Julistepeli_10": _temp1,
  "H1_Julistepeli_2": _temp2,
  "H1_Julistepeli_3": _temp3,
  "H1_Julistepeli_4": _temp4,
  "H1_Julistepeli_5": _temp5,
  "H1_Julistepeli_6": _temp6,
  "H1_Julistepeli_7": _temp7,
  "H1_Julistepeli_8": _temp8,
  "H1_Julistepeli_9": _temp9
}